module.exports = __webpack_public_path__ + "img/276.7c568e59.png";